module.exports = __webpack_public_path__ + "img/img_title_qijiandian_normal.0872157e.png";